
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface TickerContent {
  id: string;
  content_type: string;
  content: string;
  is_active: boolean;
  kit_id: string;
}

export function useTickerContent(kitId: string | null) {
  return useQuery({
    queryKey: ['ticker-content', kitId],
    queryFn: async () => {
      if (!kitId) return [];
      
      console.log('Fetching ticker content for kit:', kitId);
      
      const { data, error } = await supabase
        .from('ticker_content')
        .select('*')
        .eq('kit_id', kitId)
        .eq('is_active', true)
        .order('created_at', { ascending: true });
      
      if (error) {
        console.error('Error fetching ticker content:', error);
        throw error;
      }
      
      console.log('Ticker content:', data);
      return data as TickerContent[];
    },
    enabled: !!kitId,
    refetchInterval: 1000,
  });
}
